import { Country, State, City } from 'country-state-city';
import { v4 as uuid } from 'uuid';
import { getItemFromLocalStorage } from './localstorage';
import { usersRoles as usrRole } from 'helpers/utils';
import { parse } from 'json2csv';
import moment from 'moment';

export const capitalize = str => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
export const formatText = (text, replaceWith = '-') => {
  if (!text) return '';
  return text.toLowerCase().replaceAll('_', replaceWith);
};
export const uppercase = str => {
  if (!str) return '';
  return str.toUpperCase();
};
export const lowerCase = str => {
  if (!str) return '';
  return str.toLowerCase();
};
export const camelCase = str => {
  let ans = str.toLowerCase();
  return ans.split(' ').reduce((s, c) => `${s} ` + (c.charAt(0).toUpperCase() + c.slice(1)));
};
export const formatDataForDropdown = (list = [], key = 'name') => {
  return list.map(data => ({ ...data, name: data[key] }));
};
export const emailRegEx =
  /^[A-Za-z0-9][-A-Z-a-z0-9.!#$%&'*+-=?^_`{|}~/]+@([-A-Z-a-z0-9]+\.)+[A-Za-z]{2,5}$/;
export const passRegEx = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*?])(?=.{8,})');
export const onlyNumbers = /^\d+$/;
export const decimalNumbers = /^\d*\.?\d*$/;
export const urlRegEx =
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-z]{2,}(:[0-9]+)?(\/[^?#]*)?(\?[^#]*)?(#[^#]*)?$/i;

export const usersRoles = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  DEALER_ADMIN: 'dealer_admin',
  CLIENT: 'client',
  FLEET_MANAGE: 'fleet_manager',
  CALL_CENTER: 'call_center',
};
export const initModal = { type: null, content: { title: '', message: '' } };
export const initSideModal = { type: null, content: { title: '', subtitle: '' } };
export const initFileData = { type: null, content: { file: '', url: '' } };

export const sideModalEnum = {
  ADD_USER: 'add-user',
  ADD_ORG: 'add-organization',
  ADD_EDIT_ADMINISTRATOR_ROLE: 'add-edit-administrator-role',
  ADD_EDIT_VEHICLE: 'add-vehicle',
  ADD_EDIT_COMPANY: 'add-edit-compnay',
  ADD_EDIT_WORKSHOP_APPOINTMENT: 'add-edit-workshop-appointment',
  WORKSHOP_APPOINTMENT_REQUEST: 'workshop-appointment-request',
  DMS_INTEGRATION: 'dms-integration',
  SURVEY_FEEDBACK_DETAILS: 'survey-feedback-details',
  ADD_EDIT_OFFERS_AND_TIPS: 'add-edit-offers-and-tips',
};
export const modalEnum = {
  CONFIRMATION: 'confirmation-modal',
  COMPLETE_WORKSHOP_APPOINTMENT: 'complete-workshop-appointment',
  REJECT_WORKSHOP_APPOINTMENT: 'reject-workshop-appointment',
  ALERT_TEMPLATES: 'alert-templates',
  SEND_ALERT: 'send-alert',
  APPOINMENT_CONFIRMATION: 'appointment-confirmation',
  CHANGE_APPOINTMENT_STATUS: 'change-appointment-status',
  ADD_PAYMENT: 'add-payment',
  ADD_EDIT_BRANDS: 'Add-edit-brand',
  ADD_EDIT_MODELS: 'Add-edit-models',
  ADD_EDIT_ENGINE: 'Add-edit-engine',
  ADD_EDIT_TIRE_SIZE: 'Add-edit-tire-size',
  ADD_EDIT_DEVICE_PROVIDER: 'Add-edit-device-provider',
  ADD_EDIT_DEVICE: 'Add-edit-device',
  ADD_EDIT_PROGRAMMED_ALERTS: 'add-edit-programmed-alerts',
  ALERT_COMPLETE: 'alert-completed',
  OFFER_NOTIFY_USERS: 'offer-notify-users',
  EDIT_ALERTS: 'edit-alerts',
  LOGIN_APPOINTMENT_REQUEST: 'login-appointment-request',
};

export const countryList = Country.getAllCountries().map(country => {
  return { id: uuid(), name: country?.name, isoCode: country?.isoCode };
});

export const stateList = isoCode => {
  return State.getStatesOfCountry(isoCode).map(state => {
    return {
      id: uuid(),
      name: state?.name,
      isoCode: state?.isoCode,
      countryCode: state.countryCode,
    };
  });
};
export const cityList = (countryCode, isoCode) => {
  return City.getCitiesOfState(countryCode, isoCode).map(city => {
    return { id: uuid(), name: city?.name, stateCode: city?.stateCode };
  });
};
export const convertDropdownList = (list = [], oldKey = '', newKey = '') => {
  return (list || []).map(data => ({ ...data, [newKey]: data[oldKey] }));
};
export const vehicleTransmissionList = [
  { id: 'AUTO', name: 'Automatic', value: 'Automatic' },
  { id: 'MANUAL', name: 'Manual', value: 'Manual' },
];
export const vehicleUsedTypeList = [
  { id: 'NEW_CAR', name: 'New Car', value: 'false' },
  { id: 'USERD_CAR', name: 'Used Car', value: 'true' },
];
export const vehicleCategoryList = [
  { id: 'DEMO', name: 'Demo', value: 'demo' },
  { id: 'COMPANY', name: 'Company', value: 'company' },
  { id: 'KM_0', name: 'km 0', value: 'km 0' },
  { id: 'INDIVIDUAL', name: 'Individual', value: 'individual' },
];
export const vehicleStatusList = [
  { id: 'ACTIVE', name: 'Active', value: 'Active' },
  { id: 'CANCELED', name: 'Canceled', value: 'Canceled' },
];
export const vehicleFuelTypeList = [
  { id: 'GASOLINE', name: 'Gasoline', value: 'Gasoline' },
  { id: 'DIESEL', name: 'Diesel', value: 'Diesel' },
  { id: 'HEV', name: 'hev', value: 'hev' },
  { id: 'PHEV', name: 'phev', value: 'phev' },
  { id: 'EV', name: 'ev', value: 'ev' },
];
export const vehicleDoorsList = [
  { id: 'TWO', name: 'Two', value: '2' },
  { id: 'THREE', name: 'Three', value: '3' },
  { id: 'FOUR', name: 'Four', value: '4' },
  { id: 'FIVE', name: 'Five', value: '5' },
];
export const vehiclePlaceList = [
  { id: 'TWO', name: 'Two', value: '2' },
  { id: 'FIVE', name: 'Five', value: '5' },
  { id: 'SEVEN', name: 'Seven', value: '7' },
];

export const scrollUp = ref => {
  if (ref.current) {
    ref.current.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
};

export const hasPermission = (menu, permissionFor) => {
  const selectedOrg = getItemFromLocalStorage('org');
  if (selectedOrg?.permissions[menu] && selectedOrg?.permissions[menu][permissionFor]) {
    return true;
  } else {
    return false;
  }
};
export const removeGoogleTranslatorScript = () => {
  const scriptSrc = 'https://translate.google.com/translate_a/element.js';
  const scriptTag = document.querySelector(
    `script[src="${scriptSrc}?cb=googleTranslateElementInit"]`,
  );
  const tooltipElement = document.getElementById('goog-gt-tt');
  const tooltipContainer = document.querySelector('.VIpgJd-ZVi9od-aZ2wEe-wOHMyf');
  const skiptranslate = document.querySelector('.VIpgJd-ZVi-1od-xl07Ob-OEVmcd');

  if (scriptTag && scriptTag.parentNode) {
    scriptTag.parentNode.removeChild(scriptTag);
  }
  if (skiptranslate && skiptranslate.parentNode) {
    skiptranslate.parentNode.removeChild(skiptranslate);
  }
  if (tooltipElement && tooltipElement.parentNode) {
    tooltipElement.parentNode.removeChild(tooltipElement);
  }
  if (tooltipContainer && tooltipContainer.parentNode) {
    tooltipContainer.parentNode.removeChild(tooltipContainer);
  }
  return Promise.resolve();
};

export const getRedirectedURL = () => {
  const selectedAuthOrganization = getItemFromLocalStorage('org') || null;
  switch (selectedAuthOrganization?.role_name) {
    case usrRole.SUPER_ADMIN:
      return '/organizations';
    case usrRole.FLEET_MANAGE:
      return '/vehicles';
    case usrRole.CALL_CENTER:
      return '/workshop-appointments';
    case usrRole.DEALER_ADMIN:
      return '/users';
    default:
      return '/users';
  }
};

export const appointmentBrandStatusEnum = {
  TATA: 'Tata',
  HYUNDAI: 'Hyundai',
  SUZUKI: 'Suzuki',
  OPEL: 'Opel',
  KIA: 'KIA',
  BMW_FLOTAS: 'BMW FLOTAS',
  MINI_FLOTAS: 'MINI FLOTAS',
};

export const appointmentStatusEnum = {
  PENDING: 'PENDING',
  SCHEDULED: 'SCHEDULED',
  CANCELED: 'CANCELED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
};
export const exportCsvFile = (data, fileName, type) => {
  const blob = new Blob([data], { type: type ? type : 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', `${fileName}`);
  a.click();
};

export const convertJsonToCsv = (jsonData, options = {}) => {
  try {
    const csvData = parse(jsonData, options);
    return csvData;
  } catch (error) {
    return null;
  }
};

export const monthOptions = [
  { label: 'January', name: 'January', value: 0 },
  { label: 'February', name: 'February', value: 1 },
  { label: 'March', name: 'March', value: 2 },
  { label: 'April', name: 'April', value: 3 },
  { label: 'May', name: 'May', value: 4 },
  { label: 'June', name: 'June', value: 5 },
  { label: 'July', name: 'July', value: 6 },
  { label: 'August', name: 'August', value: 7 },
  { label: 'September', name: 'September', value: 8 },
  { label: 'October', name: 'October', value: 9 },
  { label: 'November', name: 'November', value: 10 },
  { label: 'December', name: 'December', value: 11 },
];

export const paymentsOptions = [
  { id: 'CASH_PAYMENT', name: 'Cash Payment', value: 'Cash Payment' },
  { id: 'FINANCING_AND_ENTITY', name: 'Financing and entity', value: 'Financing and entity' },
  { id: 'RENTING', name: 'Renting', value: 'Renting' },
  { id: 'LEASING', name: 'Leasing', value: 'Leasing' },
  { id: 'MULTIOPTION', name: 'Multioption', value: 'Multioption' },
];

export const getYearsList = (disablePastDaysOfDate = false, disableFutureDaysOfDate = false) => {
  const years = [];
  const initYear = !disablePastDaysOfDate ? 1950 : moment().year();
  const lastYear = !disableFutureDaysOfDate ? 2500 : moment().year();
  for (let i = initYear; i <= lastYear; i++) {
    years.push({ name: i, value: i });
  }
  return years;
};

export const generateSlotHours = () => {
  const hours = [];
  for (let i = 1; i <= 24; i++) {
    for (let j = 0; j < 60; j += 30) {
      if (i === 24 && j === 30) {
        break; // Skip minutes greater than or equal to 30 for hour 24
      }
      let hour = `${i < 10 ? '0' + i : i}:${j < 10 ? '0' + j : j}`;
      hours.push(hour);
    }
  }
  return hours;
};

export const fileTypeEnum = {
  IMAGE: 'image',
  VIDEO: 'video',
  PPT: 'ppt',
  DOC: 'doc',
  PDF: 'pdf',
  CSV: 'CSV',
};

export const NotificationModuleEnum = {
  CONFIRM_SLOT: 'confirm-slot',
  SCHEDULED_APPOINTMENT: 'scheduled-appointment',
  CANCELED_APPOINTMENT: 'appointment-canceled',
  APPOINTMENT_COMPLETE: 'appointment-completed',
  APPOINTMENT_REQUEST: 'appointment-request',
};

export const paymentsOptionsEnum = {
  CASH_PAYMENT: 'Cash Payment',
  FINANCING_AND_ENTITY: 'Financing and entity',
  RENTING: 'Renting',
  LEASING: 'Leasing',
  MULTIOPTION: 'Multioption',
};

/**
 * Formats a date using the app's existing months translation keys so month
 * names are always displayed in the active UI language.
 *
 * @param {string|Date|null|undefined} date - The date to format
 * @param {Function} t - The i18next translation function
 * @param {boolean} [withTime=false] - Whether to append HH:mm
 * @param {string|null} [inputFormat=null] - Optional moment parse format (e.g. 'YYYY-MM-DD HH:mm')
 * @returns {string} Localised date string, e.g. "20 Junio 2026 a las 14:30"
 */
export const formatLocalizedDate = (date, t, withTime = false, inputFormat = null) => {
  if (!date) return '-';
  // inputFormat lets callers specify the expected parse format (e.g. 'YYYY-MM-DD HH:mm')
  // so moment doesn't rely on heuristic parsing for combined date+time strings.
  const m = inputFormat ? moment(date, inputFormat) : moment(date);
  if (!m.isValid()) return '-';
  const day = m.format('DD');
  // Use English locale specifically to get the key name (e.g. "June") regardless
  // of whatever locale moment currently has active globally.
  const monthKey = m.clone().locale('en').format('MMMM');
  const month = t(`months.${monthKey}`);
  const year = m.format('YYYY');
  const time = m.format('HH:mm');
  if (withTime) {
    return `${day} ${month} ${year} ${t('DATE_AT')} ${time}`;
  }
  return `${day} ${month} ${year}`;
};

export const vehicleEnvironmentalLabelList = [
  { id: 'NONE', name: 'None', value: 'NONE' },
  { id: 'B', name: 'B', value: 'B' },
  { id: 'C', name: 'C', value: 'C' },
  { id: 'ECO', name: 'Eco', value: 'ECO' },
  { id: 'ZERO', name: 'Zero', value: 'ZERO' },
];
